(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define("react-carousel", ["react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["react-carousel"] = factory(require("react"), require("react-dom"));
	else
		root["react-carousel"] = factory(root["React"], root["ReactDOM"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__11__) {
return 